import { render, staticRenderFns } from "./add_job.vue?vue&type=template&id=cdddf308&scoped=true"
import script from "./add_job.vue?vue&type=script&lang=js"
export * from "./add_job.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdddf308",
  null
  
)

export default component.exports